import React from "react";

import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";

import Container from "../../../../../../../components/Container";
import Icon from "../../../../../../../components/Icon/Icon";
import Text from "../../../../../../../components/Text";
import Tooltip from "../../../../../../../components/Tooltip";

interface BaseProps {
	text: string;
	tooltipMessage: string;
}

const TextWithTooltipInfoIcon = ({ text, tooltipMessage }: BaseProps) => {
	return (
		<Container>
			<Text size="paragraph-3" color="neutral-9" weight="semi-bold">
				{text}
			</Text>
			<Container width={"1px"} />
			<Tooltip title={text} message={tooltipMessage} titleBottomLine>
				<Icon icon={faCircleInfo} size="xx-small" color="neutral-7" />
			</Tooltip>
		</Container>
	);
};

export default TextWithTooltipInfoIcon;
